
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MOZ_EvBookingBase.html?raw';
import on from 'dojo/on';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm, ProjectWizard } from "../../_loadingHelpers/VAMv2";
import { VAM2types, VAMselectEntityDialogModes } from "../../_loadingHelpers/VAMv2Types";
import "../../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Edit from '../../../moreCore/UI/Edit/Edit';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialog } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import '../../../moreCore/UI/SelectBox/SelectBox';
import "more/Legacy/Controls/TimeSlotPicker/TimeSlotPicker"; // javascript
import DateInput from '../../../moreCore/UI/DateInput/DateInput';

interface StatusTimeSlot extends more.EntityAPIResult {
    code: string;
    description: string;
    is_locked: boolean;
    is_project_lock: boolean;
    is_pruefung_lock: boolean;
    is_used: boolean;
    coloration: more.EntityAPIColor;
}

interface TimeslotData extends more.EntityAPIResult {
    date_start: Date;
    date_end: Date;
    duration: Number;
    ref_status_timeslot: StatusTimeSlot;
}




interface BookingCondition extends ApiEntity {

    description: string
    time_start_a: string
    time_end_a: string
    booking_intervall: number
    ref_time_of_day: RefTimeOfDay
    ref_ev_activity_status: RefEvActivityStatus
    ref_ev_booking_status: RefEvBookingStatus
    EL_ev_room_vt_booking_condition_vt_booking_condition: ElEvRoomVtBookingConditionVtBookingCondition[]
}

interface RefTimeOfDay extends ApiEntity {
    description: string
}

interface RefEvActivityStatus extends ApiEntity {
    description: string
}

interface RefEvBookingStatus extends ApiEntity {
    description: string
}

interface ElEvRoomVtBookingConditionVtBookingCondition extends ApiEntity {
    ref_ev_room: RefEvRoom
}

interface RefEvRoom extends ApiEntity {
    gDisp_1: string
    description: string
    code: string
}



class MOZ_EvBookingBase extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    sectionLocation: HTMLElement;
    private formContainer: HTMLElement;
    private showIfDatesAreSet: HTMLElement;
    private dateStartInput_container: HTMLElement;
    private dateEndInput_container: HTMLElement;
    private timeslotMessageNode: HTMLElement;
    private projectLeaderActionButtonSection: HTMLDivElement;
    private pruefungsAbteilungActionButtonSection: HTMLDivElement;
    private evProjectInput_container: HTMLDivElement;

    timeSlotPicker: TimeSlotPicker;

    isFullTime_container: HTMLElement;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;

    private dateInput: MdsLax<InstanceType<typeof DateInput>>;

    private evProjectInput: MdsLax<InstanceType<typeof HintBox>>;
    private bookingTitleInput: MdsLax<InstanceType<typeof Edit>>;

    //private timeslotSelect_start: SelectBox;
    //private timeslotSelect_end: SelectBox;
    private timetxt_start: MdsLax<InstanceType<typeof Edit>>;
    private timetxt_end: MdsLax<InstanceType<typeof Edit>>;

    private roomInput: MdsLax<InstanceType<typeof HintBox>>;
    private roomInputProjectLeaderSection: MdsLax<InstanceType<typeof HintBox>>;
    private roomInputPruefungsabteilungSection: MdsLax<InstanceType<typeof HintBox>>;

    private existingEntity: VAM2types.EvBooking_Base = null;

    private _timeSlotsData: TimeslotData[];
    private _bookingConditions: BookingCondition[];

    private _projectBlockingInProgress: boolean = false;

    afterSetData() {
        let data = this.sourceData as VAM2types.EvBooking_Base;

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;

        } else {
            this._onPrivilegesLoaded();
        }

        this.setStylesBasedOnData();

        this.processTimeslots();

        //  Raum und Datum sperren wenn Buchung bereits fixiert
        //
        this.lockDateAndRoom();
    }

    protected afterReady() {
        console.log("Moz-Base: afterReady");
        this.setStylesBasedOnData();
    }

    private setStylesBasedOnData() {
        let data = this.currentData as VAM2types.EvBooking_Base;

        //this.disableNode(this.showIfDatesAreSet, !data.date_start || !data.date_end); // einfach lassen, muss sowieso ausgefüllt werden

        this.dateStartInput.useTimeInput(!data.is_full_time, new Date(null, null, null, 0, 0, 0));
        this.dateEndInput.useTimeInput(!data.is_full_time, new Date(null, null, null, 23, 59, 59));

        //this.disableNode(this.dateInput, data.ref_ev_activity_status == null || data.ref_ev_room == null);
        this.disableNode(this.roomInput, data.ref_ev_activity_status == null );



        //this.disableNode(this.timeslotSelect_start, data.ref_ev_activity_status == null || data.ref_ev_room == null);
        //this.disableNode(this.timeslotSelect_end, data.ref_ev_activity_status == null || data.ref_ev_room == null);


        //this.hideNode(this.projectLeaderActionButtonSection, !this.isProjectLeader());
        this.hideNode(this.projectLeaderActionButtonSection, true); // 09.10.2025 FW: immer ausblenden weil die Blockierungsbuchungen durch Backend erfolgen

        this.hideNode(this.pruefungsAbteilungActionButtonSection, !this.isPruefung());


        this.lockDateAndRoom();
    }

    async _onClick_ProjectLeaderMagicButton() {

        let room = this.roomInputProjectLeaderSection.getValue();
        let date = this.dateInput.getValue();

        if (room == null) {
            this.showToast({
                title: "Bitte einen Raum wählen",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });
            return;
        }
        if (date == null) {
            this.showToast({
                title: "Bitte den Tag eingeben",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });
            return;
        }
        this.setAttributeValue("ref_ev_room", room, true);

        //let activityProjectBlocking = "000000fc:000000c0";
        let activityProjectBlocking = window.GP.ID_ActivityStatus_ProjectLeader_Blocking.ID;

        this._timeSlotsData = await (await this.processTimeslotsWithPromise(room.ID, activityProjectBlocking)).data;

        this._setupTimeSlotPicker();
        this.timeSlotPicker._groups[0].selectAll();
        this._onSlotSelect(null, this.timeSlotPicker._groups[0]);


        // prüfen ob bereits irgend ein slot an diesem tag eine markierung hat
        let blockingPresent = false;
        for (let x = 0; x < this._timeSlotsData.length; x++) {
            let slot = this._timeSlotsData[x] as TimeslotData;

            if (slot.ref_status_timeslot.is_used === true) {
                blockingPresent = true;
            }
        }


        if (blockingPresent) {
            this.showToast({
                title: "Projektblockierung nicht möglich",
                message: "Es ist bereits mindestens ein Slot dieses Tages belegt. Projektblockierungen erforden den gesamten Tag.",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });

            return;
        }

        this._projectBlockingInProgress = true;

        this.setAttributeValue("ev_booking_name", "Blockierungsbuchung Projektleiter", true);

        this.setAttributeValue("ref_ev_activity_status", {
            "ID": window.GP.ID_ActivityStatus_ProjectLeader_Blocking.ID,
            "code": "BLOCK-P",
            "description": window.GP.ID_ActivityStatus_ProjectLeader_Blocking["$DisplayName"]
        }, true);

        this.setAttributeValue("ref_ev_booking_status", {
            "ID": window.GP.ID_ev_booking_status_blocked.ID,
            "code": "BLOCK-P",
            "description": window.GP.ID_ev_booking_status_blocked["$DisplayName"]
        }, true);

        setTimeout(() => { this.setAttributeValue("ref_ev_room", room, true); }, 600);

        this._projectBlockingInProgress = false;

    }
    async _onClick_PruefungsabteilungMagicButton() {

        let room = this.roomInputPruefungsabteilungSection.getValue();
        let date = this.dateInput.getValue();

        if (room == null) {
            this.showToast({
                title: "Bitte einen Raum wählen",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });
            return;
        }
        if (date == null) {
            this.showToast({
                title: "Bitte den Tag eingeben",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });
            return;
        }

        this.setAttributeValue("ref_ev_room", room, true);

        //let activityProjectBlocking = "000000fc:000000c3";
        let activityBlocking = window.GP.ID_ActivityStatus_Pruefungsabteilung_Blocking.ID;

        this._timeSlotsData = await (await this.processTimeslotsWithPromise(room.ID, activityBlocking)).data;

        this._setupTimeSlotPicker();
        this.timeSlotPicker._groups[0].selectAll();
        this._onSlotSelect(null, this.timeSlotPicker._groups[0]);


        // prüfen ob bereits irgend ein slot an diesem tag eine markierung hat
        let blockingPresent = false;
        for (let x = 0; x < this._timeSlotsData.length; x++) {
            let slot = this._timeSlotsData[x] as TimeslotData;

            if (slot.ref_status_timeslot.is_used === true) {
                blockingPresent = true;
            }
        }


        if (blockingPresent) {
            this.showToast({
                title: "Prüfungsblockierung nicht möglich",
                message: "Es ist bereits mindestens ein Slot dieses Tages belegt. Prüfungsblockierungen erforden den gesamten Tag.",
                iconClass: "fas fa-exclamation-triangle",
                timeout: 5000,
                showClose: true
            });

            return;
        }

        this._projectBlockingInProgress = true;

        this.setAttributeValue("ev_booking_name", "Blockierungsbuchung Prüfungsabteilung", true);

        this.setAttributeValue("ref_ev_activity_status", {
            "ID": window.GP.ID_ActivityStatus_Pruefungsabteilung_Blocking.ID,
            "code": "BLOCK-P",
            "description": window.GP.ID_ActivityStatus_Pruefungsabteilung_Blocking["$DisplayName"]
        }, true);

        this.setAttributeValue("ref_ev_booking_status", {
            "ID": window.GP.ID_ev_booking_status_blocked_pruefung.ID,
            "code": "BLOCK-P",
            "description": window.GP.ID_ev_booking_status_blocked_pruefung["$DisplayName"]
        }, true);

        setTimeout(() => { this.setAttributeValue("ref_ev_room", room, true); }, 600);

        this._projectBlockingInProgress = false;

    }

    _onChange__StartTimeSelect(value: string) {

        //console.log("_onChange__StartTimeSelect", value);
        //this._reflectSelectedTimeToSlotPicker();
    }

    _onChange__EndTimeSelect(value: string) {
        //console.log("_onChange__EndTimeSelect", value);

        //this._reflectSelectedTimeToSlotPicker();
    }

    //private _reflectSelectedTimeToSlotPicker() {
    //    let timeHHmm = this.timeslotSelect_start.getValue();
    //    let timeParts = timeHHmm.split(":");
    //
    //    let start = new Date(this.dateInput.getValue().getTime() );
    //    start.setHours(parseInt(timeParts[0]));
    //    start.setMinutes(parseInt(timeParts[1]));
    //
    //    timeHHmm = this.timeslotSelect_end.getValue();
    //    timeParts = timeHHmm.split(":");
    //
    //    let end = new Date(this.dateInput.getValue().getTime());
    //    end.setHours(parseInt(timeParts[0]) - 1);
    //    end.setMinutes(parseInt(timeParts[1]));
    //
    //    this.timeSlotPicker._groups[0].unselectAll();
    //
    //    let slotWidget_start = this.timeSlotPicker._groups[0].getSlotByStartDate(start);
    //    slotWidget_start.select(true);
    //
    //    let slotWidget_end = this.timeSlotPicker._groups[0].getSlotByStartDate(end);
    //    slotWidget_end.select(true);
    //}

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {

        //console.log(this.id, "_onChanged", key, value)
        
        if (key == "ref_ev_room") {
            this._onChanged_EvRoom(key, value, null);
            this.setStylesBasedOnData();
        }

        if (key == "ref_ev_activity_status") {
            this.timetxt_start.setValue(null);
            this.timetxt_end.setValue(null);

            this.roomInput.setValue(null);
            this.setStylesBasedOnData();
            this.processTimeslots();
        }

        if (key == "ref_ev_room") {
            //console.log("_onChanged", key, value);
            let dayValue = this.dateInput.getValue();
            let dayValueStr = this.dateToString(dayValue, "yyyy-MM-dd");

            let dayValueNewStr = this.dateToString(value, "yyyy-MM-dd");

            if (dayValueStr != dayValueNewStr) {
                this.processTimeslots();
            }
        }else if (key == "date_start") {
            this.processTimeslots();
            this.timetxt_start.setValue(null);
            this.timetxt_end.setValue(null);
        }


    }

    private loadBookingConditions() {

        let data = this.currentData as VAM2types.EvBooking_Base;

        if (data.ref_ev_activity_status == null) {
            return;
        }

        this.roomInput.addAdditionalRequestParameter("activity", data.ref_ev_activity_status.ID);

        this.RequestManager.handleAs = "jsonWithDate";
        this.RequestManager.callfunction("Webtool_API_RoomSlots__GetCondiions",
            {
                "activity": data.ref_ev_activity_status.ID
            },
            lang.hitch(this, this._onLoadBookingConditionsResponse),
            lang.hitch(this, this._onLoadBookingConditionsError)
        );
    }

    private _onLoadBookingConditionsResponse(response: { "data": BookingCondition[], "message": string}) {
        console.log("_onLoadBookingConditionsResponse", response);

        this._bookingConditions = response.data;
    }

    private _onLoadBookingConditionsError(error) {

    }

    private processTimeslots(directEvRoomId?: string, directActivityStatusID?: string) {

        if (this._projectBlockingInProgress === true) {
            return;
        }

        let data = this.currentData as VAM2types.EvBooking_Base;
        //console.log("processTimeslots", this.currentData, "existing", this.existingEntity);
        if (data.date_start != null && typeof data.date_start.getTime == "function" && (data.ref_ev_room != null || directEvRoomId != null) && (data.ref_ev_activity_status != null || directActivityStatusID != null)) {

            let start = new Date(data.date_start.getTime());
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);

            let end = new Date(start.getTime());
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);

            this.StandbyStart();
            this.RequestManager.handleAs = "jsonWithDate";
            this.RequestManager.post(window.appRoot + "EvBooking/GetTimeslotData",
                {
                    JsonData: this.JSON.stringify({
                        "start": this.dateToLocalISOString(start),
                        "end": this.dateToLocalISOString(end),
                        "room": directEvRoomId || data.ref_ev_room.ID,
                        "activity": directActivityStatusID || data.ref_ev_activity_status.ID,
                        "bookingId": data.ID
                    })
                },
                lang.hitch(this, this.onGetTimeslotData_Response),
                lang.hitch(this, this.onGetTimeslotData_Error)
            );
        }
    }

    private async processTimeslotsWithPromise(directEvRoomId?: string, directActivityStatusID?: string) {
        let data = this.currentData as VAM2types.EvBooking_Base;

        if (data.date_start != null && typeof data.date_start.getTime == "function" && (data.ref_ev_room != null || directEvRoomId != null) && (data.ref_ev_activity_status != null || directActivityStatusID != null)) {

            let start = new Date(data.date_start.getTime());
            start.setHours(0);
            start.setMinutes(0);
            start.setSeconds(0);

            let end = new Date(start.getTime());
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);

            this.StandbyStart();
            this.RequestManager.handleAs = "jsonWithDate";
            let request: dojo.request.Promise<{ message: string, data: TimeslotData[] }> = this.RequestManager.xhr( //"Property Xhr does not exist" - DOCH TUATS, EXISTIERT SEHR GUT SOGAR
                window.appRoot + "EvBooking/GetTimeslotData",
                "POST",
                {
                    JsonData: this.JSON.stringify({
                        "start": this.dateToLocalISOString(start),
                        "end": this.dateToLocalISOString(end),
                        "room": directEvRoomId || data.ref_ev_room.ID,
                        "activity": directActivityStatusID || data.ref_ev_activity_status.ID,
                        "bookingId": data.ID
                    })
                }
            );

            //request.always(lang.hitch(this, this.StandbyStop ))
            request.always(response => this.StandbyStop())
            /*request.then(lang.hitch(this, function (response) {
                this._timeSlotsData = response.data;
                this._setupTimeSlotPicker(response);
                this.timeSlotPicker._groups[0].selectAll();
            }));*/

            return request;
        }
    }

    private _getTimeformat(date: Date) {
        return this.leadingZeros(date.getHours(), 2) + ":" + this.leadingZeros(date.getMinutes(), 2);
    }

    private onGetTimeslotData_Response(response: { message: string, data: TimeslotData[] } ) {
        //console.log("timeslots", response);
        this.StandbyStop();

        this._timeSlotsData = response.data;

        this.timeslotMessageNode.innerHTML = response.message;
        if (response.message != null) {
            this.UiModder.domClass.remove(this.timeslotMessageNode, "w3-hide");
            this.UiModder.domClass.add(this.timeSlotPicker.domNode, "w3-hide");
        } else {
            this.UiModder.domClass.add(this.timeslotMessageNode, "w3-hide");
            this.UiModder.domClass.remove(this.timeSlotPicker.domNode, "w3-hide");
        }


        if (this.currentData.date_start) {
            let start_selectedTime = this._getTimeformat(this.currentData.date_start);

            this.timetxt_start.setValue(start_selectedTime);
        } else {
            this.timetxt_start.setValue(null);
        }

        if (this.currentData.date_end) {
             let end_selectedTime = this._getTimeformat(this.currentData.date_end);

            this.timetxt_end.setValue(end_selectedTime);
        } else {
            this.timetxt_end.setValue(null);
        }

        this._setupTimeSlotPicker();
    }

    private onGetTimeslotData_Error(error) {
        this.StandbyStop();
    }

    private isProjectLeader(): boolean {
        return this.hasUserRole("ProjectLead");
    }
    private isSekretariat(): boolean {
        return this.hasUserRole("Sekretariat");
    }
    private isPruefung(): boolean {
        return this.hasUserRole("Pruefung");
    }

    private lockDateAndRoom() {
        if (this.currentData.ref_ev_booking_status) {
            if (window.GP.ID_ev_booking_status_fb.ID == this.currentData.ref_ev_booking_status.ID) {
                this.disableNode(this.dateInput, true);
                this.disableNode(this.roomInput, true);
                this.timeSlotPicker.set("readOnly", true);
                this.hideNode(this.timeslotMessageNode, true);
            }
            else {
                this.hideNode(this.timeslotMessageNode, false);
            }
        }
    }
    private _setupTimeSlotPicker() {

        this.timeSlotPicker.setupGroupMapping = lang.hitch(this, function (groupWidget) {
            // übersteuern...

            groupWidget.title = groupWidget.entity.description;
            groupWidget.subTitle = "";

            if (groupWidget.__clickHandler) {
                groupWidget.__clickHandler.remove();
            }

            //groupWidget.__clickHandler = groupWidget.on("click_icon", lang.hitch(this, this._onClickGroupIcon));
        });

        this.timeSlotPicker.setupSlotMapping = lang.hitch(this, function (slotWidget) {
            // übersteuern...

            if (typeof this.currentData.date_start.getTime != "function") {
                return;
            }

            var hours = slotWidget.entity.date_start.getHours();
            var minutes = slotWidget.entity.date_start.getMinutes();
            var selectedDate = new Date(this.currentData.date_start.getTime());
            selectedDate.setHours(hours);
            selectedDate.setMinutes(minutes);

            var slotStartDate = selectedDate;

            var interval = slotWidget.entity.duration;

            var slotEndDate = new Date(slotStartDate.getTime() + interval * 60000);

            slotWidget.startDate = new Date(slotStartDate.valueOf());
            slotWidget.set("duration", interval);
            slotWidget.title = "<p>{0}</p><p>{1}</p>".format(slotStartDate.toTimeString().substring(0, 5), slotEndDate.toTimeString().substring(0, 5));
            slotWidget.domNode.style.minWidth = "{0}px".format(50); // breite 50px
        });

        let data = lang.clone(this.currentData) as VAM2types.EvBooking_Base;

        this.timeSlotPicker.clear();
        let group = this.timeSlotPicker.addGroup(data.ref_ev_room, data.ref_ev_room.ID, data.ref_ev_room);
        group.on("selected", lang.hitch(this, this._onSlotSelect));


        // vorabprüfung der slots ob eine projekblockierung dabei ist ( gilt nur für NICHT-Projektleiter )
        //                                                                       // ↓
        let projectBlockingPresent = false;                                      // ↓
        let pruefungBlockingPresent = false;                                     // ↓
        for (let x = 0; x < this._timeSlotsData.length; x++) {                   // ↓
            let slot = this._timeSlotsData[x] as TimeslotData;                   // ↓
                                                                                 // ↓
            if (slot.ref_status_timeslot.is_project_lock === true && !this.isProjectLeader()) {
                projectBlockingPresent = true;
            }

            if (slot.ref_status_timeslot.is_pruefung_lock === true && !this.isPruefung()) {
                pruefungBlockingPresent = true;
            }
        }

        //  Markierung/Blockierung/Farben verarbeiten
        //
        for (let x = 0; x < this._timeSlotsData.length; x++) {
            let slot = this._timeSlotsData[x] as TimeslotData;

            let slotWidget = group.addSlot(slot) as TimeSlotPicker_TimeSlot;

            if (slot.ref_status_timeslot.is_used === true /*&&
                !this._isTimeslotInBookingRange(slotWidget)*/ // wenn die gewählten Slots zur aktuellen Buchung gehören, dann keine Einschränkungen enwenden
            ) {
                slotWidget.permanentColor = slot.ref_status_timeslot.coloration.BackColor.Hex;
                slotWidget.displaystate();
            }

            slotWidget.canSelect = lang.hitch(this, this._timeSlot_CanSelect);

            //let slotIsInCurrentDataRange = slotWidget.startDate.getTime() <= this.data
            //TODO: hier weitermachen!!!!

            if (projectBlockingPresent || pruefungBlockingPresent) {
                //  ein NICHT-projektleiter darf einfach garnix mit den blockierten Slots machen
                //
                slotWidget.set("locked", true);
                slotWidget.canSelect = function () { return false; }

            } else {

                if (slot.ref_status_timeslot.is_project_lock === true && this.isProjectLeader()) {
                    if (slot.ref_status_timeslot.is_locked === true && slot.ref_status_timeslot.is_project_lock !== true) {
                        slotWidget.set("locked", true);
                        slotWidget.canSelect = function () { return false; }
                    }
                }
                else if (slot.ref_status_timeslot.is_pruefung_lock === true && this.isPruefung()) {
                    if (slot.ref_status_timeslot.is_locked === true && slot.ref_status_timeslot.is_pruefung_lock !== true) {
                        slotWidget.set("locked", true);
                        slotWidget.canSelect = function () { return false; }
                    }
                }
                else {
                    if (slot.ref_status_timeslot.is_locked === true /*&&
                    !this._isTimeslotInBookingRange(slotWidget) */// wenn die gewählten Slots zur aktuellen Buchung gehören, dann keine Einschränkungen enwenden
                    ) {
                        slotWidget.set("locked", true);
                        slotWidget.canSelect = function () { return false; }
                    }
                }
            }
        }



        // slot markieren
        if (data.date_start != null && data.date_end != null) {

            let slot_start = this.timeSlotPicker._groups[0].getSlotByStartDate(data.date_start);
            if (slot_start) {
                slot_start.canSelect = lang.hitch(this, this._timeSlot_CanSelect);
                slot_start.set("locked", false);
                slot_start.selected = true;
                slot_start.permanentColor = null;
                slot_start.displaystate();

                //slot_start.domNode.scrollIntoView({ block: "center", inline: "nearest" });


                var interval = slot_start.entity.duration;

                let next_slot_date = new Date(slot_start.startDate.getTime() + interval * 60000);
                // schleife!! --------------------
                while (next_slot_date.getTime() < data.date_end.getTime()) {

                    let slot_next = this.timeSlotPicker._groups[0].getSlotByStartDate(next_slot_date);
                    slot_next.canSelect = lang.hitch(this, this._timeSlot_CanSelect);
                    slot_next.set("locked", false);
                    slot_next.selected = true;
                    slot_next.permanentColor = null;
                    slot_next.displaystate();

                    next_slot_date = new Date(next_slot_date.getTime() + interval * 60000);
                }
                // -------------------------


                let slot_end = this.timeSlotPicker._groups[0].getSlotByEndDate(data.date_end);
                if (slot_end && slot_end != slot_start) {
                    slot_end.canSelect = lang.hitch(this, this._timeSlot_CanSelect);
                    slot_end.set("locked", false);
                    slot_end.selected = true;
                    slot_end.permanentColor = null;
                    slot_end.displaystate();
                }
            }


        }

    } // setup ende

    private _isTimeslotInBookingRange(slotWidget: TimeSlotPicker_TimeSlot) {
        let data = this.currentData as VAM2types.EvBooking_Base;
        let slotDate = slotWidget.startDate;

        //if (slotDate >= data.date_start && slotDate <= data.date_end) {
        //    return true;
        //}
        if (slotDate.getFullYear() + "-" + slotDate.getMonth() + "-" + slotDate.getDate() == data.date_start.getFullYear() + "-" + data.date_start.getMonth() + "-" + data.date_start.getDate()) {
            return true;
        }

        return false;
    }

    private _timeSlot_CanSelect(currentSlotWidget: TimeSlotPicker_TimeSlot): boolean {

        let currentSlotTime = currentSlotWidget.startDate;
        let interval = 60;
        let trailingMinutes = 0;

        var nextSlotTimes = [];
        var processedMinutes = interval;
        nextSlotTimes.push(new Date(currentSlotTime.getTime() + processedMinutes * 60000));
        var loop = 0;
        while (processedMinutes <= trailingMinutes) {
            nextSlotTimes.push(new Date(currentSlotTime.getTime() + processedMinutes * 60000));

            processedMinutes = processedMinutes + interval;
            loop++;
            if (loop > 10000) break; // Notausstieg
        }

        //console.log("nextSlotTimes müssen frei sein: ", nextSlotTimes);

        var selectionAllowed = true;
        for (var y = 0; y < nextSlotTimes.length; y++) {
            var nexteSlotTime = nextSlotTimes[y];

            // slotwidget suchen
            //
            var nextSlotWidget = currentSlotWidget.groupWidget.getSlotByStartDateHHmm(nexteSlotTime.getHours(), nexteSlotTime.getMinutes());
            var previousSlotWidget = currentSlotWidget.groupWidget.getSlotByStartDateHHmm(nexteSlotTime.getHours() - 2, nexteSlotTime.getMinutes());
            if (nextSlotWidget != null && previousSlotWidget != null) {
                if (previousSlotWidget.get("selected") === true && nextSlotWidget.get("selected") === true) {
                    selectionAllowed = false; // vorher und nachher ist bereits selektiert. also muss das aktuelle auch seletiert sein und darf daher nicht entfernt werden
                    break;
                }
            }
        }

        //console.log("_timeSlot_CanSelect", );
        // Buchungsbedingungen prüfen
        //

        if (this._bookingConditions && this._bookingConditions.length > 0) {
            let existingSelection = this.timeSlotPicker._groups[0].get("selection") as TimeSlotPicker_TimeSlot[];
            if (existingSelection.length > 0) {
                let firstSlotDate = existingSelection[0].startDate;
                let firstSlotEndDate = existingSelection[0].endDate;
                let currentSlotEndTime = currentSlotWidget.endDate;

                for (let i = 0; i < this._bookingConditions.length; i++) {
                    let condition = this._bookingConditions[i];

                    if (condition.time_start_a != null && condition.time_end_a != null) {

                        if (condition.time_start_a == "" || condition.time_start_a == null) {
                            condition.time_start_a = "00:00"
                        }

                        let conditionRageStartDate = new Date(currentSlotTime.getTime());
                        conditionRageStartDate.setHours(parseInt(condition.time_start_a.split(":")[0]));
                        conditionRageStartDate.setMinutes(parseInt(condition.time_start_a.split(":")[1]));
                        conditionRageStartDate.setSeconds(0);

                        if (condition.time_end_a == "" || condition.time_end_a == null) {
                            condition.time_end_a = "23:59"
                        }

                        let conditionRageEndDate = new Date(currentSlotTime.getTime());
                        conditionRageEndDate.setHours(parseInt(condition.time_end_a.split(":")[0]));
                        conditionRageEndDate.setMinutes(parseInt(condition.time_end_a.split(":")[1]));
                        conditionRageEndDate.setSeconds(0);

                        //  firstSlotDate entscheidet in welche condition gegangen wird. vormittag/nachmittag..
                        //
                        if (firstSlotEndDate.getTime() >= conditionRageStartDate.getTime() &&
                            firstSlotEndDate.getTime() <= conditionRageEndDate.getTime()) {

                            // passende endzeit prüfen (aktuelle auswahl)
                            //
                            if (currentSlotEndTime.getTime() >= conditionRageStartDate.getTime() &&
                                currentSlotEndTime.getTime() <= conditionRageEndDate.getTime()
                            ) {
                                // start/ende ist in der Range der Condition

                                // Zum Schluss noch die Dauer prüfen
                                //
                                let durationMinutes = (currentSlotEndTime.getTime() - firstSlotDate.getTime()) / 60 / 1000;
                                if (durationMinutes <= condition.booking_intervall) {
                                    // auch hier alles gut...
                                } else {
                                    selectionAllowed = false;
                                }

                            } else {
                                selectionAllowed = false;
                            }
                        }


                    }
                }
            }
        }

        return selectionAllowed;
    }

    private _onSlotSelect(slotWidget: TimeSlotPicker_TimeSlot, group: TimeSlotPicker_Group) {
        //console.log("_onSlotSelect", slotWidget);

        let selection = group.get("selection") as TimeSlotPicker_TimeSlot[];

        if (selection.length > 0) {
            let date_start = selection[0].startDate;

            let endSlot = selection[selection.length - 1];

            let interval = ((endSlot.entity as any) as TimeslotData).duration;
            let date_end = new Date(endSlot.startDate.getTime() + (interval as number) * 60000);


            let start_selectedTime = this._getTimeformat(date_start);
            let end_selectedTime = this._getTimeformat(date_end);

            //this.timeslotSelect_start.setValue(start_selectedTime);
            //this.timeslotSelect_end.setValue(end_selectedTime);

            this.timetxt_start.setValue(start_selectedTime);
            this.timetxt_end.setValue(end_selectedTime);

            this.dateStartInput.setValue(date_start);
            this.dateEndInput.setValue(date_end);
        } else {

            this.timetxt_start.setValue(null);
            this.timetxt_end.setValue(null);
            //this.dateStartInput.setValue(null);
            //this.dateEndInput.setValue(null);
        }
    }

    private _onChanged_EvBookingName(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }

    private _onChanged_EvRoom(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {

        if (newValue) {

        }
    }
    private _onChanged_FullTime(key: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        this.setStylesBasedOnData();

        //    this._onChanged_Dates("date_start", this.currentData.date_start);
        //    this._onChanged_Dates("date_end", this.currentData.date_end);
    }


    private _onChangeAudienceSeatingLayoutInput(value?: any) {
        //console.debug("_onChangeAudienceSeatingLayoutInput", value);
    }
    private _onClick_OpenProjectSED(evt) {

        let newCallback = null;
        if (this.hasFeature("EvProject/ProjectWizard") && this.hasUserRole(["Projects_Create", "Projects_Edit"])) {
            newCallback = lang.hitch(this, this._onSelect_CreateNewEvProject);
        }

        this.loadSelectEntityDialog(evt,
            VAMselectEntityDialogModes.evProject,
            lang.hitch(this, this._onCallback_Dlg),
            newCallback
        );
    }
    private _onCallback_Dlg(mode: string, data, items) {
        if (items.length == 0 || !items) {
            return;
        }

        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet
        let entity = {
            ID: items[0].entry.value, gDisp_1: items[0].entry.label
        }

        if (mode == "selectEvProject") {
            this.evProjectInput.setValue(entity)
        }

        if (mode == "selectEvRoom") {
            let room = items[0].entry.data;
            this.roomInput.setValue(room);
        }

        //this.previousSEDvalue = items;
    }

    private _onSelect_CreateNewEvProject(selectEntityDlg: MdsLax<InstanceType<typeof SelectEntityDialog<VAM2types.EvProjectEntity_Base>>>) {
        let projectWizard = new ProjectWizard();

        let dlg = new GenericDialog();

        dlg.addNodeToContent(projectWizard.domNode);
        dlg.keepOpen = true;
        dlg.destroyOnClose = false;

        on(projectWizard, "saveComplete", lang.hitch(this, this._onProjectWizardSaved, dlg, projectWizard));

        dlg.show(null, this.translations["Projects__CreateNew"], null, null, "saveclose", lang.hitch(this, this._onProjectWizardDlgResult, dlg, projectWizard));

        projectWizard.startup();
    }

    private _onProjectWizardDlgResult(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizard>>, result: number) {
        if (result >= 1) { // OK/JA
            // speicherversuch
            projectWizard.save();
            dlg.disableAllButtons();
            setTimeout(lang.hitch(dlg, dlg.disableAllButtons, false), 10000); // unschön, aber falls was is, einen save-Error bekommen wir nicht mit...
        } else {
            dlg.close(-1, true);
        }
    }

    private _onProjectWizardSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>, projectWizard: MdsLax<InstanceType<typeof ProjectWizard>>) {
        let projectID = projectWizard.getEntityId();
        let displayname = projectWizard.getDisplayname();

        dlg.close(-1);

        let tmpEntity = {};
        tmpEntity[this.evProjectInput.valueAttribute] = projectID;
        tmpEntity[this.evProjectInput.labelAttribute] = displayname;


        this.evProjectInput.setValue(tmpEntity);
    }

    private setupHintboxes() {
        this.evProjectInput.addInlineButton(lang.hitch(this, this._onClick_OpenProjectSED));
        this.roomInput.addInlineButton(lang.hitch(this, this._onClick_OpenRoomSED));
        this.roomInputProjectLeaderSection.enableSelectEntityDialog();
    }


    private _onClick_OpenRoomSED(evt) {
        //debugger;
        this.loadSelectEntityDialog(evt,
            "selectEvRoom",
            lang.hitch(this, this._onCallback_Dlg),
            null,
            this.roomInput.getAdditionalRequestParams(true)
        );
    }

    setRequestData(start: Date, end: Date, bookingId: string = null) {
        this.roomInput.addAdditionalRequestParameter('dateStart', start ? this.dateToLocalISOString(start) : null);
        this.roomInput.addAdditionalRequestParameter('dateEnd', end ? this.dateToLocalISOString(end) : null);

        if (bookingId) {
            this.roomInput.addAdditionalRequestParameter('bookingId', bookingId);
        }
    }


    private _onPrivilegesLoaded() {
        // alle Rechte des Entities sind jetzt geladen, d.h. wir können synchron auswerten
        // falls wir hier sind obwohl this.existingEntity leer ist, dann wird die Rolle gewöhnlich allgemeingültig abgefragt
        let editPriv = this.hasUserRole("EvBooking_Edit", null, this.existingEntity);
        let deletePriv = this.hasUserRole("EvBooking_Delete", null, this.existingEntity);
        let evCastPriv = this.hasUserRole("EvBooking_EvCast", null, this.existingEntity);
        let evProgramPriv = this.hasUserRole("EvBooking_EvProgram", null, this.existingEntity);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupHintboxes();

        this.SEDconfigCallfunction = "Webtool_API_SED_GetConfig";

        this.addOnchanged("ev_booking_name", lang.hitch(this, this._onChanged_EvBookingName));
        this.addOnchanged("ref_ev_room", lang.hitch(this, this._onChanged_EvRoom));
        this.addOnchanged("is_full_time", lang.hitch(this, this._onChanged_FullTime));
        this.addOnchanged("ref_ev_activity_status", lang.hitch(this, this.loadBookingConditions));

        //if (this.hasModule("EvBooking/NoIsFullTimeCheckbox")) this.UiModder.domClass.add(this.isFullTime_container, "w3-hide w3-disable");

        if (this.isSekretariat() || this.isPruefung()) {
            this.evProjectInput.setMandatory(false);
            this.hideNode(this.evProjectInput_container);
        }

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MOZ_EvBookingBase);
